module.exports = __webpack_public_path__ + "img/media-discord.ed98a3cf.png";